const API = import.meta.env.VITE_API_BASE || '/api';

let sequence = 3;

function generateVehiculoId() {
  sequence += 1;
  return `VH-${String(sequence).padStart(3, '0')}`;
}

function today(daysOffset = 0) {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString().slice(0, 10);
}

let vehiculosMock = [
  {
    id: 'VH-001',
    patente: 'AB123CD',
    marca: 'Mercedes Benz',
    modelo: 'Actros 2545',
    anio: 2021,
    tipo: 'Camión',
    chasis: 'MB-CHS-9901',
    motor: 'OM 471',
    capacidadKg: 18000,
    volumenM3: 72,
    odometro: 178000,
    choferAsignado: 'Juan Pérez',
    empresa: 'Central',
    activo: true,
    documentacion: {
      vtvNumero: 'VTV-8891',
      vtvEmision: today(-250),
      vtvVencimiento: today(60),
      vtvAvisoDias: 30,
      seguroCompania: 'Sancor',
      seguroPoliza: 'POL-00231',
      seguroVencimiento: today(15),
      seguroFranquicia: '150000',
      cedulaVerdeVto: today(120),
      cedulaAzulVto: '',
      adjuntos: ['actros_vtv_2024.pdf', 'seguro_actros.pdf'],
    },
    mantenimiento: {
      proximoServiceKm: 190000,
      proximoServiceFecha: today(90),
      estadoNeumaticos: '70%',
      rotacionKm: 25000,
      observaciones: 'Verificar suspensión trasera en próximo service.',
    },
    comercial: {
      costoKm: 420,
      costoHora: 3500,
      costoFijoMensual: 280000,
      propietario: 'Flota Propia',
      choferAsignado: 'Juan Pérez',
    },
  },
  {
    id: 'VH-002',
    patente: 'AC987BD',
    marca: 'Iveco',
    modelo: 'Daily 70C',
    anio: 2019,
    tipo: 'Furgón',
    chasis: 'IV-CHS-5544',
    motor: 'F1C',
    capacidadKg: 3500,
    volumenM3: 18,
    odometro: 256500,
    choferAsignado: 'María López',
    empresa: 'Sucursal Norte',
    activo: true,
    documentacion: {
      vtvNumero: 'VTV-7765',
      vtvEmision: today(-390),
      vtvVencimiento: today(-5),
      vtvAvisoDias: 30,
      seguroCompania: 'La Caja',
      seguroPoliza: 'POL-00542',
      seguroVencimiento: today(-1),
      seguroFranquicia: '',
      cedulaVerdeVto: today(45),
      cedulaAzulVto: today(180),
      adjuntos: ['cedula_verde_daily.pdf'],
    },
    mantenimiento: {
      proximoServiceKm: 265000,
      proximoServiceFecha: today(45),
      estadoNeumaticos: '5 mm',
      rotacionKm: 15000,
      observaciones: 'Revisar frenos delanteros, desgaste irregular.',
    },
    comercial: {
      costoKm: 260,
      costoHora: 2100,
      costoFijoMensual: 185000,
      propietario: 'Flota Propia',
      choferAsignado: 'María López',
    },
  },
  {
    id: 'VH-003',
    patente: 'AE456FG',
    marca: 'Toyota',
    modelo: 'Hilux 4x4',
    anio: 2022,
    tipo: 'Pick-up',
    chasis: 'TY-CHS-2231',
    motor: '1GD-FTV',
    capacidadKg: 1000,
    volumenM3: 8,
    odometro: 86500,
    choferAsignado: 'Carlos Díaz',
    empresa: 'Central',
    activo: false,
    documentacion: {
      vtvNumero: 'VTV-9901',
      vtvEmision: today(-100),
      vtvVencimiento: today(200),
      vtvAvisoDias: 30,
      seguroCompania: 'Allianz',
      seguroPoliza: 'POL-00931',
      seguroVencimiento: today(120),
      seguroFranquicia: '100000',
      cedulaVerdeVto: today(365),
      cedulaAzulVto: '',
      adjuntos: ['hilux_seguro.pdf'],
    },
    mantenimiento: {
      proximoServiceKm: 95000,
      proximoServiceFecha: today(120),
      estadoNeumaticos: '80%',
      rotacionKm: 20000,
      observaciones: 'Inactivo hasta nuevo proyecto.',
    },
    comercial: {
      costoKm: 180,
      costoHora: 1600,
      costoFijoMensual: 120000,
      propietario: 'Tercerizado',
      choferAsignado: 'Carlos Díaz',
    },
  },
];

export async function listVehiculos(filters = {}) {
  console.log('[STUB] listVehiculos', API, filters);
  const { search, tipo, activo, estadoVtv, estadoSeguro } = filters;
  let data = [...vehiculosMock];

  if (search) {
    const normalized = search.trim().toLowerCase();
    data = data.filter(vehiculo => {
      return (
        vehiculo.patente.toLowerCase().includes(normalized) ||
        vehiculo.marca.toLowerCase().includes(normalized) ||
        vehiculo.modelo.toLowerCase().includes(normalized)
      );
    });
  }

  if (tipo && tipo !== 'todos') {
    data = data.filter(vehiculo => vehiculo.tipo === tipo);
  }

  if (typeof activo === 'boolean') {
    data = data.filter(vehiculo => vehiculo.activo === activo);
  }

  if (estadoVtv && estadoVtv !== 'todos') {
    data = data.filter(vehiculo => getEstadoVencimiento(vehiculo.documentacion?.vtvVencimiento) === estadoVtv);
  }

  if (estadoSeguro && estadoSeguro !== 'todos') {
    data = data.filter(
      vehiculo => getEstadoVencimiento(vehiculo.documentacion?.seguroVencimiento) === estadoSeguro,
    );
  }

  return { data, total: data.length };
}

export async function getVehiculo(id) {
  console.log('[STUB] getVehiculo', API, id);
  return vehiculosMock.find(vehiculo => vehiculo.id === id) ?? null;
}

export async function createVehiculo(payload) {
  console.log('[STUB] createVehiculo', API, payload);
  const id = generateVehiculoId();
  const nuevo = { id, ...payload };
  vehiculosMock = [nuevo, ...vehiculosMock];
  return { ok: true, id };
}

export async function updateVehiculo(id, payload) {
  console.log('[STUB] updateVehiculo', API, id, payload);
  vehiculosMock = vehiculosMock.map(vehiculo => {
    if (vehiculo.id !== id) {
      return vehiculo;
    }
    return { ...vehiculo, ...payload };
  });
  return { ok: true };
}

export function getEstadoVencimiento(fechaVto, anticipacionDias = 30) {
  if (!fechaVto) {
    return 'NA';
  }
  const hoy = new Date();
  const vto = new Date(fechaVto);
  const diff = (vto - hoy) / (1000 * 60 * 60 * 24);
  if (diff < 0) {
    return 'VENCIDO';
  }
  if (diff <= anticipacionDias) {
    return 'PRONTO';
  }
  return 'OK';
}

export function getVehiculosMock() {
  return vehiculosMock;
}
